import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";

function Allmarket() {
  // const [user, setUsers] = useState(null);
  const [userr, setUserss] = useState(null);
  const [useadvertisement, setadvertisement] = useState(null);
  const [useadvertisement1, setadvertisement1] = useState(null);
  const [usefetchAdvertisements2, setfetchAdvertisements2] = useState(null);
  const [useallMarketData, setuseallMarketData] = useState(null);
  const [usefetchAdvertisements3, setfetchAdvertisements3] = useState(null);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [time, setTime] = useState(null);
  console.warn(time);

  const formatTime12Hour = (time24Hour) => {
    const [hour, minute] = time24Hour.split(":");
    const hour12 = hour % 12 || 12;

    const period = hour < 12 ? "AM" : "PM";
    return `${hour12}:${minute} ${period}`;
  };

  useEffect(() => {
    loaduser();
    results();
    loaduser1();
  }, []);
  const handleYearChange = (event) => {
    setYear(event.target.value);
  };
  const handleMonthChange = (event) => {
    setMonth(event.target.value);
  };
  const handleSubmit = () => {
    results(year, month);
  };
  const [year, setYear] = useState("2020");
  const [month, setMonth] = useState("01");
  const [useresults, setresults] = useState(null);
  const [uniqueDates, setUniqueDates] = useState([]);
  const [uniquemarketname, setUniquemarketname] = useState([]);
  const monthAbbreviations = {
    "01": "Jan",
    "02": "Feb",
    "03": "Mar",
    "04": "Apr",
    "05": "May",
    "06": "Jun",
    "07": "Jul",
    "08": "Aug",
    "09": "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };

  const results = async (year, month) => {
    setLoading(true);

    console.warn(year, month);
    try {
      // Get the current date, year, and month
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonthIndex = currentDate.getMonth(); // 0-based index (0 = Jan, 11 = Dec)
      const monthAbbreviations = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const currentMonthAbbr = monthAbbreviations[currentMonthIndex];
      // alert(monthAbbreviations)
      // Use passed values or default to current year and month
      const formData = new FormData();
      formData.append("year", year || currentYear);
      formData.append(
        "month",
        month || String(currentMonthIndex + 1).padStart(2, "0"),
      ); // Ensure "MM" format

      // const response = await fetch(`${process.env.REACT_APP_API_URL}public/api/satta-king-record-chart`, {
      const response = await fetch(
        // "https://a7-sattakingg.com/Admin/public/api/satta-king-record-chart",
        `${process.env.REACT_APP_API_URL}/Admin/public/api/satta-king-record-chart`,

        {
          method: "POST",
          body: formData,
        },
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.warn(data); // Log the response data

      const selectedMonthAbbr =
        monthAbbreviations[parseInt(month, 10) - 1] || currentMonthAbbr;
      // alert(monthAbbreviations)

      if (
        data.data &&
        data.data[selectedMonthAbbr] &&
        data.data[selectedMonthAbbr].length > 0
      ) {
        setresults(data.data[selectedMonthAbbr]);
        const dates = data.data[selectedMonthAbbr].map((entry) => entry.date);
        const uniqueDates = [...new Set(dates)];
        setUniqueDates(uniqueDates);

        const marketNames = data.data[selectedMonthAbbr].map(
          (entry) => entry.market_name,
        );
        const uniqueMarketNames = [...new Set(marketNames)];
        setUniquemarketname(uniqueMarketNames);
        console.warn("Unique Market Names:", uniqueMarketNames);
      } else {
        console.error(
          `No data available for the selected or default month (${currentMonthAbbr}) and year.`,
        );
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false); // Set loading to false after the data is fetched or error occurs
    }
  };

  const [usemarketname, setusemarketname] = useState("");

  const [useyearr, setyearr] = useState("");
  const [titlee, settitlee] = useState("");

  const loaduser = async () => {
    // const market_id = localStorage.getItem("market_id");
    // alert(market_id)
    // console.warn(market_id)

    // alert(user_id);
    let url = `${process.env.REACT_APP_API_URL}public/api/satta-chart-record2024`;
    // console.warn(url);
    // const formData = new FormData();
    // formData.append("market_id", market_id);
    // alert(dev_id)
    var config = {
      method: "POST",
      url: url,
    };
    axios
      .post(url, config)
      .then(function (response) {
        const res = JSON.stringify(response.data);
        const objectRes = JSON.parse(res);
        setusemarketname(objectRes);
        console.warn(objectRes);

        const year = objectRes.data.year;
        const title = objectRes.data.title;
        // alert(livetime)
        setyearr(year);
        settitlee(title);
      })
      .finally(() => {
        // setTimeout(() => {
        // }, 1000);
      });
  };

  const handleClick1 = async (market_id) => {
    navigate("/Result");
    localStorage.setItem("marketchart_id", market_id);
  };

  const [usemarketnamee, setusemarketnamee] = useState("");
  const [useyear, setyear] = useState("");
  const [title, settitle] = useState("");
  //  console.log(usetitleyear)

  const loaduser1 = async () => {
    let url = `${process.env.REACT_APP_API_URL}public/api/satta-chart-record2023`;

    var config = {
      method: "POST",
      url: url,
    };
    axios
      .post(url, config)
      .then(function (response) {
        const res = JSON.stringify(response.data);
        const objectRes = JSON.parse(res);
        setusemarketnamee(objectRes);

        const year = objectRes.data.year;
        const title = objectRes.data.title;
        // alert(livetime)
        setyear(year);
        settitle(title);
      })
      .finally(() => {
        // setTimeout(() => {
        // }, 1000);
      });
  };
  const handleClick2 = async (market_id) => {
    navigate("/Market");
    localStorage.setItem("marketchart_id", market_id);
  };


  // =================================================



  const [marketData, setMarketData] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState("");
  const [selectedYear, setSelectedYear] = useState("2026");


  useEffect(() => {
    fetchMarketData();
  }, []);

  const fetchMarketData = async () => {
    try {
      const response = await fetch(
        // "https://a7-sattakingg.com/Admin/public/api/getAllMarketData",
        `${process.env.REACT_APP_API_URL}/Admin/public/api/getAllMarketData`,

        {
          method: "POST",
        }
      );

      const data = await response.json();

      if (data.data && data.data.allMarketData) {
        setMarketData(data.data.allMarketData);
      }
    } catch (error) {
      console.error("Error fetching market data:", error);
    }
  };

  const handleShowChart = () => {
    if (!selectedMarket) {
      alert("Please select market");
      return;
    }

    localStorage.setItem("marketchart_id", selectedMarket);
    localStorage.setItem("yearrr", selectedYear);

    navigate("/Markets");
  };


  useEffect(() => {
    if (marketData.length > 0 && !selectedMarket) {
      const saved = localStorage.getItem("marketchart_id");

      if (saved) {
        setSelectedMarket(saved);
      } else {
        setSelectedMarket(marketData[0].market_id);
      }
    }
  }, [marketData]);



  ////////////////// genral-setting////////////////////////



  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/Admin/public/api/genral-setting`)
      .then((res) => res.json())
      .then((result) => {
        setData(result.data); // ✅ yahi fix tha
      })
      .catch((error) => {
        console.log("API Error:", error);
      });
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <section
            className="ads-container"
            style={{ marginTop: "5px", marginBottom: "5px" }}
          >
            <div className="column-ad">
              <div className="ads_box">
                <p>
                  <strong>🙏🏿नमस्कार साथियो 🙏🏿</strong>
                </p>

                <p>
                  <strong>
                    अपनी गेम का रिजल्ट हमारी web साइट पर लगवाने के लिए संपर्क
                    करें।
                  </strong>
                </p>

                <p>
                  <strong>----ARUN BHAI ----</strong>
                </p>

                <p>
                  <a
                    href={`https://wa.me/${data?.whatsapp_link}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="https://i.ibb.co/4RJCLbSB/whatsapp.png"
                      alt="whatsapp"
                      width="40"
                    />
                  </a>
                </p>

                <p>
                  NOTE: इस नंबर पर लीक गेम नही मिलता गेम लेने वाले भाई कॉल या
                  मैसेज न करें।
                </p>

                <p>
                  किसी भी भाई को किसी भी तरह की कोई शिकायत या परेशानी हो तो हमसे
                  telegram पर संपर्क करे{" "}
                  <a
                    href={data?.telegram_link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="https://res.cloudinary.com/dfjmg7wty/image/upload/v1707012878/gswbu36srlfwiaippr1g.webp"
                      alt="Telegram link"
                      width="40"
                    />
                  </a>
                </p>
              </div>
            </div>
          </section>

          <section className="allmarket">
            <div className="octoberresultchart">
              {/* 
                          <div class="gcse-search"></div> */}

              <div className="container">
                <div className="row">
                  <h2 className="mb-4 text-center">SATTA KING CHART</h2>
                  <div className="col-md-12 d-flex justify-content-center">
                    <div className="chart_record">
                      <div className="d-flex  gap-2">
                        <select
                          className="form-control w-50 mx-auto"
                          value={selectedMarket}
                          onChange={(e) => {
                            setSelectedMarket(e.target.value);
                            localStorage.setItem("marketchart_id", e.target.value);
                          }}
                        >
                          <option value="">Select Market</option>

                          {marketData.map((market) => (
                            <option key={market.market_id} value={market.market_id}>
                              {market.market_name}
                            </option>
                          ))}
                        </select>

                        <select
                          className="form-control w-50 mx-auto"
                          value={selectedYear}
                          onChange={(e) => setSelectedYear(e.target.value)}
                        >
                          <option value="2022">2022</option>
                          <option value="2023">2023</option>
                          <option value="2024">2024</option>
                          <option value="2025">2025</option>
                          <option value="2026">2026</option>
                        </select>
                        <button
                          className="btn btn-success btn_check"
                          onClick={handleShowChart}
                        >
                          Show Chart
                        </button>
                      </div>
                    </div>
                  </div>


                  <section className="tablebox1" id="sattachart">
                    <div className="container text-center">


                      {/* MARKET DROPDOWN */}
                      <div className="chart_record">
                        <div className="d-flex  gap-2">


                        </div>


                        {/* YEAR DROPDOWN */}

                        <div className="mb-3">

                        </div>

                        {/* BUTTON */}


                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
            <section className="chart_header">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <h2>SATTA RESULT CHART</h2>
                  </div>
                </div>
              </div>
            </section>

            <div className="newtable bg-light">
              <div className="container-fluid">
                {uniquemarketname.length > 1 && (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <th className="forfirtcolor">Date</th>
                          {uniqueDates.slice(0, 1).map((date) => (
                            <React.Fragment>
                              {useresults
                                .filter((entry) => entry.date === date)
                                .slice(0, 15)
                                .map((entry) => (
                                  <th className="forfirtcolor">
                                    {entry.market_name}
                                  </th>
                                ))}
                            </React.Fragment>
                          ))}
                        </tr>

                        {uniqueDates.map((date) => (
                          <tr>
                            <React.Fragment>
                              <td className="forfirtcolor">
                                {new Date(date).getDate()}/
                                {new Date(date).getMonth() + 1}/
                                {new Date(date).getFullYear()}
                              </td>
                              {useresults
                                .filter((entry) => entry.date === date)
                                .slice(0, 31)
                                .map((entry) => (
                                  <React.Fragment>
                                    <td>
                                      {/* {entry.result} */}
                                      {entry.result}
                                      {/* {entry.result <= 9 || entry.result === "" ? (
                                  <div class="sattaresult"><font><span><strong><h1 class="text-red blink-soft">Wait</h1></strong></span></font></div>
                                ) : (
                                  entry.result
                                )} */}
                                      {/* {(entry.result === "" || /^\d$/.test(entry.result)) ? (
                                    <div className="sattaresult">
                                      <font>
                                        <span>
                                          <strong>
                                            <h1 className="text-red blink-soft">Wait</h1>
                                          </strong>
                                        </span>
                                      </font>
                                    </div>
                                  ) : (
                                    entry.result)} */}
                                    </td>
                                  </React.Fragment>
                                ))}
                            </React.Fragment>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>

            <div className="forChart">
              <h5 className="text-center">
                <strong>What is a7-sattakingg ?</strong>
              </h5>
              <p>
                A7sattaking official (a7 satta) is a web platform / website
                which is popular for publishing various satta king games results
                as they are announced. There are thousands of websites which
                shows satta results but they lack consistency and trustworthy
                result while a7-sattaking.com constantly publishes satta king
                games results everyday which makes it a reliable platform for
                satta king players. Also a7-sattaking.com provides full year
                satta king record chart which is crucial for satta players for
                analyzing or predicting upcoming satta results.
              </p>

              <h5 className="text-center">
                <strong>
                  What are famous satta king games on a7-sattakingg.com ?
                </strong>
              </h5>
              <p>
                There are many games whose results are published every day such
                as delhi bazar satta king, faridabad satta king, satta shree
                ganesh (also called SG satta king), disawer satta king and
                ghaziabad satta. Their monthly charts including shree ganesh
                chart can be seen on a7-sattakingg.com home page.
              </p>

              <h5 className="text-center">
                <strong>
                  Do a7-sattakingg.com publishes DELHI SATTA RESULT ?
                </strong>
              </h5>
              <p>
                Yes, Delhi satta is one of the popular games played in the
                Indian continent. It is also called dl bazar satta or db satta.
                It is named after India's capital city New Delhi. Some people
                also call it new delhi satta or dl satta. a7-sattakingg.com
                shows Delhi satta results as soon as they are published. The
                usual time for Delhi satta result is 03:15 PM everyday, although
                the result may be delayed by 5–10 minutes depending on the
                information source.
              </p>

              <h5 className="text-center">
                <strong>Real-Time Updates on A7SATTAKINGG Games</strong>
              </h5>
              <p>
                In the fast-paced world of satta, timing is crucial.
                a7-sattakingg.com recognizes this and ensures real-time updates
                on results and related information so users stay informed and
                engaged.
              </p>

              <h5 className="text-center">
                <strong>User-Friendly Interface</strong>
              </h5>
              <p>
                Navigating through a satta platform should be seamless whether
                you're a seasoned player or a beginner. a7-sattakingg.com
                provides an easy interface where users can see satta charts,
                yesterday results and yearly charts with complete records.
              </p>

              <h5 className="text-center">
                <strong>Reliability of Results</strong>
              </h5>
              <p>
                One of the main reasons a7-sattakingg holds a reputable position
                is its commitment to delivering accurate and reliable satta
                results which helps build trust among users.
              </p>

              <h5 className="text-center">
                <strong>How to play satta king games ?</strong>
              </h5>
              <p>
                To play satta king games you usually contact people related to
                satta games who place your bet and provide winning amounts on
                correct predictions. a7-sattakingg does not organize or endorse
                any satta games, although advertisements may appear on this web
                portal.
              </p>

              {/* <h5 className="text-center">
                <strong>
                  What time sadar bazar satta king result is published on
                  a7-sattakingg ?
                </strong>
              </h5> */}
              {/* <p>
                Sadar bazar satta king results are usually published everyday at
                1:30 PM. Click here to see{" "}
                <a
                  href="https://a7-sattakingg.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sadar Bazar Satta Chart 2025
                </a>
              </p> */}

              <h5 className="text-center">
                <strong>Security and Privacy Measures</strong>
              </h5>
              <p>
                a7-sattakingg maintains strong security and privacy measures to
                protect user data. Please read our{" "}
                <Link
                  to={"/privacypolicy"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  privacy policy
                </Link>{" "}
                and{" "}
                <Link
                  to={"/termsconditions"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  terms and conditions
                </Link>
                .
              </p>
            </div>
          </section>
        </>
      )}
    </>
  );
}

export default Allmarket;
